import React, { useRef } from 'react';
import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import SectionsInfo from '../SectionsInfo';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

import useWindowSize from '../../hooks/useWindowSize';
import ReviewCard from './ReviewCard';
import removeHtmlTags from '../../helpers/removeHtmlTags';

function Reviews({ data }) {
  const lang = Cookies.get('i18next') || 'en';
  const { width } = useWindowSize();
  const swiperRef = useRef(null);
  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };
  return (
    <div className="reviews">
      <div className="container medium">
        <div className="reviews__content">
          <SectionsInfo
            handleNext={handleNext}
            handlePrev={handlePrev}
            isSlider
            showButtons={data.data.length > 4}
            title={data.title[lang]}
            description={data.content_title[lang]}
          />
          <Swiper
            loop
                // eslint-disable-next-line no-return-assign
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="our__team-slider"
            style={{ marginTop: width > 768 ? 32 : 24 }}
            spaceBetween={width > 768 ? 24 : 12}
            slidesPerView={width > 768 ? 4 : 1.1}
          >
            {data.data.map((e) => (
              <SwiperSlide key={e.id}>
                <ReviewCard
                  type={e.type ? e.type[lang] : ''}
                  imgAlt={e.image.alt_attribute[lang]}
                  img={e.image.webp_url}
                  text={removeHtmlTags(e.description[lang])}
                  name={e.full_name[lang]}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default Reviews;
